export default __webpack_public_path__ + "static/media/vuesax-linear-bag-happy2.aab81c45.svg";